
/**
*@function setCountry
*@description Sets the country and language in the URL of the website based on the data provided, 
*and redirects to the corresponding website.
*@param {Object} data - The data object with information about the country.
*@param {string} data.id - The ID of the country.
*@author Yojhan Atuesta <yojhan.atuesta@gradiweb.com>
*/
const setCountry = (data) => {
  const listOfLanguages = ["en", "fr", "es"];
  const country = data.id.split(" -")[0].toLowerCase();
  const urlPath = new URL(window.location.href);
  const language = urlPath.pathname?.split("-")?.[1] || undefined;
  if (country === "us") {
    window.location.href = "https://us.mercihandy.com/"
  }
  else if (country === "fr") {
    window.localStorage.removeItem("pathSaved")
    window.location.href = "https://mercihandy.com/"
  } else {
    if (language && listOfLanguages.includes(language) && country === "eu") {
      const newPathname = `${language}-${country}`;
      window.localStorage.setItem("pathSaved", newPathname);
      window.location.pathname = `/${newPathname}`;
    }
    else if (country === "uk") {
      const newPathname = `en-${country}`;
      window.localStorage.setItem("pathSaved", newPathname);
      window.location.pathname = `/${newPathname}`;
    }
    else {
      const newPathname = `${listOfLanguages[0]}-${country}`;
      window.localStorage.setItem("pathSaved", newPathname);
      window.location.pathname = `/${newPathname}`;
    }
  }

}

/**
*@function setCountryMobile
*@description Sets the country and language in the URL of the website based on the data provided 
*(mobile version), and redirects to the corresponding website.
*@param {Object} data - The data object with information about the country.
*@param {string} data.target.value - The value of the selected country.
*@author Yojhan Atuesta <yojhan.atuesta@gradiweb.com>
*/

const setCountryMobile = (data) => {
  const listOfLanguages = ["en", "fr", "es"];
  const country = data.target.value;
  const urlPath = new URL(window.location.href);
  const language = urlPath.pathname?.split("-")?.[1] || undefined;
  if (country === "us") {
    window.location.href = "https://us.mercihandy.com/"
  }
  else if (country === "fr") {
    window.localStorage.removeItem("pathSaved")
    window.location.href = "https://mercihandy.com/"
  } else {
    if (language && listOfLanguages.includes(language) && country === "eu") {
      const newPathname = `${language}-${country}`;
      window.localStorage.setItem("pathSaved", newPathname);
      window.location.pathname = `/${newPathname}`;
    } else if (country === "uk") {
      const newPathname = `en-${country}`;
      window.localStorage.setItem("pathSaved", newPathname);
      window.location.pathname = `/${newPathname}`;
    } else {
      const newPathname = `${listOfLanguages[0]}-${country}`;
      window.localStorage.setItem("pathSaved", newPathname);
      window.location.pathname = `/${newPathname}`;
    }
  }

}

/**
*@function validateCountry
*@description Validates if the country and language in the URL are correct and updates them if necessary.
*/
const validateCountry = () => {
  const listOfLanguages = ["en", "fr", "es"];
  const actualCountry = window.localStorage.getItem("pathSaved");
  const pathname = new URL(window.location.href).pathname.replace("/", "").trim();
  if (actualCountry && listOfLanguages.indexOf(pathname.split("-")[0]) === -1) {
    window.location.pathname = `/${actualCountry}`;
  }
  if (pathname.includes("eu")) {
    document.getElementById("weglot-switcher-1").classList.add("active");
    document.getElementById("weglot-switcher-1").classList.remove("inactive");
    document.getElementsByClassName("language_selector-mobile")[0].classList.add("active");
    document.getElementsByClassName("language_selector-mobile")[0].classList.remove("inactive");
  } else {
    document.getElementById("weglot-switcher-1").classList.remove("active");
    document.getElementById("weglot-switcher-1").classList.add("inactive");
    document.getElementsByClassName("language_selector-mobile")[0].classList.remove("active");
    document.getElementsByClassName("language_selector-mobile")[0].classList.add("inactive");
  }
}

/**
*@function switchListLanguages
*@description Opens and closes the language switcher list when the user clicks on the desktop 
*language switcher.
*@author Yojhan Atuesta <yojhan.atuesta@gradiweb.com>
*/
const switchListLanguages = () => {
  const languageSwitcher = document.getElementById("language-switcher");
  const languageSwitcherList = document.getElementById("language-switcher_list");
  languageSwitcher.classList.toggle("open");
  languageSwitcher.classList.toggle("closed");
  languageSwitcherList.classList.toggle("active");
}

/**
*@function switchListLanguagesMobile
*@description Opens and closes the language switcher list when the user clicks on the mobile language 
*switcher.
*@author Yojhan Atuesta <yojhan.atuesta@gradiweb.com>
*/

const switchListLanguagesMobile = () => {
  const languageSwitcher = document.getElementById("language-switcher-mobile");
  const languageSwitcherList = document.getElementById("language-switcher_list-mobile");
  languageSwitcher.classList.toggle("open");
  languageSwitcher.classList.toggle("closed");
  languageSwitcherList.classList.toggle("active");
}

/**
*@function changeLanguage
*@description Changes the language in the URL of the website based on the language selected by the user, 
*and redirects to the corresponding website.
*@param {Object} data - The data object with information about the language selected.
*@param {string} data.getAttribute("data-l") - The value of the selected language.
*@author Yojhan Atuesta <yojhan.atuesta@gradiweb.com>
*/
const changeLanguage = (data) => {
  const language = data.getAttribute("data-l");
  const actualUrl = new URL(window.location.href);
  const pathname = actualUrl.pathname.replace("/", "").trim();
  const country = pathname.split("-")[1].toLowerCase();
  const newPathname = `${language}-${country}`;
  window.localStorage.setItem("pathSaved", newPathname);
  window.location.href = newPathname;
}


document.getElementById("weglot-switcher-1").addEventListener("click", switchListLanguages);
document.getElementsByClassName("language_selector-mobile")[0].addEventListener("click", switchListLanguagesMobile);
document.getElementById("country_selector_mobile").addEventListener("change", setCountryMobile);

validateCountry();